import * as React from "react"
import { Box } from "@mui/material"

import { HierarchicalTextBlock } from "@components"


export default function AdminNewListedDetailsDrawerContentTabInternalInfo({ itemID, productID, searchID, variantID, taskID }) {
    return <Box display="flex" flexDirection="column">
        <HierarchicalTextBlock title="Item ID: " titleValue={itemID}/>
        <HierarchicalTextBlock title="Product ID: " titleValue={productID}/>
        <HierarchicalTextBlock title="Search ID: " titleValue={searchID}/>
        <HierarchicalTextBlock title="Task ID: " titleValue={taskID}/>
        <HierarchicalTextBlock title="Variant ID: " titleValue={variantID}/>
    </Box>
}